import React from 'react';
import { Link } from 'react-router-dom';
import CoreComponent from './Core';

class Navbar extends CoreComponent{
    constructor(props) {
      super(props);
      this.state={
        dataHolder:null
      }
    }
    refresh(){
      this.httpPost("/api/organ/ajax/updates/")
      .then(dataHolder => {
        if (this.isNull(dataHolder.current_user))
          window.location.href = "/organ/login/";
        else
          this.setState({ dataHolder });
      });
    }
    logOut(){
      this.lockScreen();
      this.httpPost('/api/organ/ajax/logout')
      .then(dataHolder => {
        if (dataHolder.status === 1)
          window.location.href = "/organ/login/";
        else
        {
          this.unLockScreen();
          this.showToast(dataHolder.message,'danger');
        }
      })
      .catch(err=>{
        this.unLockScreen();
        this.showToast('خطایی رخ داده است.لطفا مجدد تلاش نمایید','danger');
      });
    }
    componentDidMount(){
        this.refresh();
        this.interval = setInterval(() => this.refresh(), 90000);
    }
    componentDidUpdate(){
        //پلاگین جی کوئری مربوط به باز و بسته شدن آیتم های منو رو راه اندازی میکنیم
        window.bindSideBar();
    }
    componentWillUnmount() {
        //تایمر رو حذف میکنیم تا رم رو درگیر نگه نداره
        clearInterval(this.interval);
    }
    ChangeLegal(e){
      this.lockScreen();
      this.httpPost('/api/organ/ajax/change_legal', {id:e.target.value})
      .then(dataHolder => {
          if (dataHolder.status === 1)
            window.location.href = "/organ/";
        else
        {
            this.unLockScreen();
            this.showToast(dataHolder.message,'danger');
        }
      })
      .catch(err=>{
        this.unLockScreen();
        this.showToast('خطایی رخ داده است.لطفا مجدد تلاش نمایید','danger');
      });
    }
    renderUniversityMenues(){
      if (this.state.dataHolder.current_user.LegalPerson.role_id !== 1 && this.state.dataHolder.current_user.LegalPerson.role_id !== 2 &&
          this.state.dataHolder.current_user.LegalPerson.role_id !== 3 && this.state.dataHolder.current_user.LegalPerson.role_id !== 4 &&
          this.state.dataHolder.current_user.LegalPerson.role_id !== 5) return null;

      return [
          <li>
              <Link to="/uni/edit/">
                  <i className="fad fa-books"></i>
                  <span>اطلاعات مرکز</span>
              </Link>
          </li>
        ,
          <li>
              <Link to="/accounts/">
                  <i className="fab fa-internet-explorer"></i>
                  <span>دسترسی های مرکز</span>
              </Link>
          </li>
        ,
          <li>
              <Link to="/accounts/emails/">
                  <i className="fal fa-at"></i>
                  <span>دسترسی های ایمیلی</span>
              </Link>
          </li>
        ,
          <li>
              <Link to="/accounts/mobiles/">
                  <i className="fas fa-mobile-android-alt"></i>
                  <span>دسترسی های موبایلی</span>
              </Link>
          </li>
        ,
          <li>
              <Link to="/cashes/">
                  <i className="fal fa-badge-dollar"></i>
                  <span>مالی</span>
              </Link>
          </li>
        ,
          <li>
              <Link to="/report/downloads/">
                  <i className="fal fa-analytics"></i>
                  <span>آمار  دریافتها</span>
              </Link>
          </li>
        ,
          <li>
              <Link to="/requests/">
                  <i className="fad fa-cloud-download"></i>
                  <span>لیست  دریافتها</span>
              </Link>
          </li>
        ,
        <li>
            <Link to="/persons/">
                <i className="fad fa-users"></i>
                <span>ساختار سازمانی</span>
            </Link>
        </li>
      ]
    }
    renderConferencesMenues(){
      if (this.state.dataHolder.current_user.LegalPerson.role_id !== 6) return;

      return [
          <li>
              <Link to="/conf/edit/">
                  <i className="fad fa-books"></i>
                  <span>اطلاعات همایش</span>
              </Link>
          </li>
          ,
          <li>
              <Link to="/cpapers/">
                  <i className="fal fa-file-alt"></i>
                  <span>مدیریت مقالات</span>
              </Link>
          </li>
          ,
          <li>
              <Link to="/persons/">
                  <i className="fad fa-users"></i>
                  <span>ساختار سازمانی</span>
              </Link>
          </li>
          ,
          <li>
              <Link to="/posts/">
                  <i className="fa fa-rss"></i>
                  <span>اخبار کنفرانس</span>
              </Link>
          </li>
      ]
    }
    renderJournalMenues(){
      if (this.state.dataHolder.current_user.LegalPerson.role_id !== 7) return null;

      return [
          <li>
              <Link to="/journal/edit/">
                  <i className="fad fa-books"></i>
                  <span>اطلاعات مجله</span>
              </Link>
          </li>
          ,
          <li>
              <Link to="/persons/">
                  <i className="fad fa-users"></i>
                  <span>ساختار سازمانی</span>
              </Link>
          </li>
          ,
          <li>
              <Link to="/issues/">
                  <i className="fad fa-books"></i>
                  <span>اطلاعات شماره ها</span>
              </Link>
          </li>
          ,
          <li>
              <Link to="/jpapers/">
                  <i className="fal fa-file-alt"></i>
                  <span>مدیریت مقالات</span>
              </Link>
          </li>
          ,
          <li>
              <Link to="/posts/">
                  <i className="fa fa-rss"></i>
                  <span>اخبار مجله</span>
              </Link>
          </li>
      ]
    }
    render(){
      if (this.state.dataHolder === null )return null;
      return  [
                <header className="main-header">
                  <nav className="navbar navbar-static-top">
                    <div style={{"color":"#6b6b6b","lineHeight":"47px","paddingRight":"9px","display":"inline-block"}}>
                      {!this.isEmpty(this.state.dataHolder.users) ? 
                        <select style={{"border":"none","background":"white","padding":"5px","margin-right":"5px"}} defaultValue={this.state.dataHolder.current_user.id} onChange={e=>this.ChangeLegal(e)}>
                          {this.state.dataHolder.users.map(_user=>
                          _user.LegalPerson.role_id === 1 && <option value={_user.id}>{!this.isNull(_user.LegalPerson) && _user.LegalPerson.name} {!this.isBlank(_user.aff) && "(" + _user.aff + ")"}</option>
                          )}
                          {this.state.dataHolder.users.sort((a,b)=>b.LegalPerson.link_cell-a.LegalPerson.link_cell).map(_user=>
                          _user.LegalPerson.role_id === 7 && <option value={_user.id}>{!this.isNull(_user.LegalPerson) && _user.LegalPerson.name} {!this.isBlank(_user.aff) && "(" + _user.aff + ")"}</option>
                          )}
                          {this.state.dataHolder.users.sort((a,b)=>b.LegalPerson.link_cell-a.LegalPerson.link_cell).map(_user=>
                          _user.LegalPerson.role_id === 6 && <option value={_user.id}>{!this.isNull(_user.LegalPerson) && _user.LegalPerson.name} {!this.isBlank(_user.aff) && "(" + _user.aff + ")"}</option>
                          )}
                          {this.state.dataHolder.users.map(_user=>
                          (_user.LegalPerson.role_id !== 1 && _user.LegalPerson.role_id !== 6 && _user.LegalPerson.role_id !== 7) && <option value={_user.id}>{!this.isNull(_user.LegalPerson) && _user.LegalPerson.name} {!this.isBlank(_user.aff) && "(" + _user.aff + ")"}</option>
                          )}
                        </select>
                      : 
                        "::" + this.state.dataHolder.current_user.LegalPerson.name
                      }
                    </div>                
                    <div className="navbar-custom-menu">
                      <ul className="nav navbar-nav" >                          
                        <li className="dropdown user user-menu">
                          <a href="#" className="dropdown-toggle" data-toggle="dropdown">
                              <img src={this.toImageUrl(this.state.dataHolder.current_user.RealPerson,'real_person')} className="user-image" alt="" />
                              <span className="hidden-xs">{this.state.dataHolder.current_user.RealPerson.fname + ' ' + this.state.dataHolder.current_user.RealPerson.lname}</span>
                          </a>
                          <ul className="dropdown-menu">
                              <li className="user-header">
                                  <img src={this.toImageUrl(this.state.dataHolder.current_user.RealPerson,'real_person')} className="img-circle" alt="" />
                                  <p>
                                      {this.state.dataHolder.current_user.aff}
                                      <small>{this.state.dataHolder.current_user.RealPerson.fname + ' ' + this.state.dataHolder.current_user.RealPerson.lname}</small>
                                  </p>
                              </li>
                              <li className="user-footer">
                                  <div className="pull-right">
                                      <a onClick={e=>this.logOut()} className="btn btn-default btn-flat">خروج</a>
                                  </div>
                              </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </nav>
                </header>
              ,
                <aside className="main-sidebar" style={{"position":"absolute"}}>
                  <section className="sidebar" style={{"height": "auto"}}>
                      <div className="user-panel text-center">
                          <div className="image">
                            {(this.state.dataHolder.current_user.LegalPerson.role_id === 6 || this.state.dataHolder.current_user.LegalPerson.role_id === 51 || this.state.dataHolder.current_user.LegalPerson.role_id === 7 ) ?
                              <img src="/assets/img/favicon.png" style={{"width":"80px","height":"80px"}} alt={this.state.dataHolder.current_user.LegalPerson.name} />
                            :
                              <img src={this.toImageUrl(this.state.dataHolder.current_user.LegalPerson,'legal_person')} style={{"width":"80px","height":"80px"}} alt={this.state.dataHolder.current_user.LegalPerson.name} />
                            }
                          </div>
                      </div>
                      <ul className="sidebar-menu tree" data-widget="tree">                    
                          <li>
                              <Link to="/dashboard/">
                                  <i className="fal fa-home"></i> <span>داشبرد</span>
                              </Link>
                          </li>
                          {this.renderUniversityMenues()}
                          {this.renderConferencesMenues()}
                          {this.renderJournalMenues()}
                          <li>
                              <Link to="/tickets/">
                                  <i className="fal fa-life-ring"></i> <span>پشتیبانی</span>
                              </Link>
                          </li>
                          <li>
                              <a onClick={e=>this.logOut()}>
                                  <i className="fal fa-sign-out-alt"></i>
                                  <span>خروج از سیستم</span>
                              </a>
                          </li>
                      </ul>
                  </section>
                </aside>
              ];
    }
  }
  export default Navbar;